import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { Currency, Rate } from '@zeusm/personal/core/entities';
import { DictionariesApi } from '@zeusm/personal/store';
import { buildPersonalApiUrl } from '@zeusm/shared/core/helpers';

import { GetDictionaryRes } from '../models';

@Injectable()
export class DictionariesApiService implements DictionariesApi {
  readonly #http = inject(HttpClient);

  getCurrencies(): Observable<Currency[]> {
    const api = buildPersonalApiUrl('currencies/');

    return this.#http.get<GetDictionaryRes<Currency>>(api).pipe(map(res => res.items));
  }

  getRates(): Observable<Rate[]> {
    const api = buildPersonalApiUrl('rates/');

    return this.#http.get<GetDictionaryRes<Rate>>(api).pipe(map(res => res.items));
  }
}
